import React, { useState } from "react";
import ConfirmModal from "./../UI/confirmStatusModal";
export function ConfirmModalGenerator({ color, title, status }, click) {
  return function({ close }) {
    return (
      <ConfirmModal>
        <h3>
          شما وضعیت{" "}
          <span
            style={{
              color: color
            }}
          >
            {title}
          </span>{" "}
          انتخاب کردید.از ادامه کار مطمین هستید؟
        </h3>
        <div className="btn_Wrapper">
          <button className="btn cancel" onClick={close}>
            خیر
          </button>
          <button
            onClick={() => {
              close();
              click(status);
            }}
            className="btn"
          >
            بله
          </button>
        </div>
      </ConfirmModal>
    );
  };
}

const HoursOptions = [
  { title: "دو ساعت", value: 2 },
  { title: "سه ساعت", value: 3 },
  { title: "پنچ ساعت", value: 5 },
  { title: "یک روز", value: 24 },
  { title: "دو روز", value: 48 },
  { title: "سه روز", value: 72 },
  { title: "چهار روز", value: 96 },
  { title: "یک هفته", value: 168 }
];
export function ConfirmFollowUpModal({ color, title, status }, click) {
  return function({ close }) {
    let hours = HoursOptions[0].value;
    return (
      <ConfirmModal FollowUp={true}>
        <h3>
          شما وضعیت{" "}
          <span
            style={{
              color: color
            }}
          >
            {title}
          </span>{" "}
          را نتخاب کردید.در صورت اطمینان مدت زمان یادآوری زنگ بعد رو انتخاب و
          گزینه تایید را بزنید
        </h3>
        <div className="selectWrapper">
          <select
            onChange={e => {
              hours = e.target.value;
            }}
          >
            {HoursOptions.map(({ value, title }) => (
              <option key={value} value={value}>
                {title}
              </option>
            ))}
          </select>
        </div>
        <div className="btn_Wrapper">
          <button className="btn cancel" onClick={close}>
            لغو
          </button>
          <button
            onClick={() => {
              close();
              click(status, hours);
            }}
            className="btn"
          >
            تایید
          </button>
        </div>
      </ConfirmModal>
    );
  };
}
